var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#020319;}\r\n\t.st1{opacity:0.6;fill:#1FAA00;enable-background:new    ;}\r\n\t.st2{opacity:0.3;fill:#1FAA00;enable-background:new    ;}\r\n\t.st3{fill:#1FAA00;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,2.5c11.9,0,21.5,9.6,21.5,21.5S35.9,45.5,24,45.5S2.5,35.9,2.5,24S12.1,2.5,24,2.5 M24,0.5 C11,0.5,0.5,11,0.5,24S11,47.5,24,47.5S47.5,37,47.5,24S37,0.5,24,0.5L24,0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-3_1_",
    className: "st1",
    d: "M22.9,4.5c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S22.3,4.5,22.9,4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-3_2_",
    className: "st2",
    d: "M19.8,5c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.2,5,19.8,5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25,4.6v2c9.2,0.5,16.5,8.1,16.5,17.4c0,0.3,0,0.6,0,0.8h2c0-0.3,0-0.5,0-0.8C43.5,13.6,35.3,5.1,25,4.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.2efbeaee.svg";
export { ForwardRef as ReactComponent };